/**
 * TanStack Router: /vacation/requests
 *
 * This route file was auto-generated by the route generation script.
 * Component: VacationRequestsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import VacationRequestsPage from '@/app/vacation/requests/page'

/**
 * Route: /vacation/requests
 * Layout: _auth (authenticated)
 * Component: VacationRequestsPage
 */
export const Route = createFileRoute('/_auth/vacation/requests')({
  component: VacationRequestsPage,
})
